import JobPortalJobReducer from "./job/reducer";
import JobApplicationReducer from "./jobApplication/reducer";

export { JobPortalJobReducer, JobApplicationReducer };